import React, { useState } from 'react';
import {
  Box, Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogTitle,
  LinearProgress, Stack, TextField, Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../../../components/admin';
import { useHydrantPlanyQuery, useCreatePlanMutation } from '../../../api/JsdhNotifikaceService/service/HydrantBodMutations';
import { HydrantBodService } from '../../../api/JsdhNotifikaceService/service/HydrantBodService';

const HydrantPlanyPage: React.FC = () => {
  const { data: plany } = useHydrantPlanyQuery();
  const create = useCreatePlanMutation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [nazev, setNazev] = useState('');
  const [datumOd, setDatumOd] = useState('');
  const [datumDo, setDatumDo] = useState('');

  const ulozit = () => {
    create.mutate({ nazev, datumOd, datumDo }, { onSuccess: () => { setOpen(false); setNazev(''); setDatumOd(''); setDatumDo(''); } });
  };

  return (
    <Box>
      <PageHeader title="Kontrolní plány" subtitle="Kampaně kontrol (2× ročně)" action={
        <Button startIcon={<AddIcon />} variant="contained" onClick={() => setOpen(true)}>Nový plán</Button>
      } />
      <Stack spacing={2}>
        {(plany ?? []).map((p) => {
          const pct = p.celkemPolozek > 0 ? Math.round((p.dokoncenoPolozek / p.celkemPolozek) * 100) : 0;
          return (
            <Card key={p.plan.id}>
              <CardContent>
                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="subtitle1">{p.plan.nazev} ({p.plan.stav})</Typography>
                  <Stack direction="row" spacing={1}>
                    <Button size="small" onClick={() => navigate(`/admin/hydranty-evidence/plany/${p.plan.id}`)}>Detail</Button>
                    <Button size="small" onClick={() => HydrantBodService.stahniPlanReportPdf(p.plan.id)}>Souhrn PDF</Button>
                  </Stack>
                </Stack>
                <Typography variant="body2" color="text.secondary">{p.plan.datumOd} – {p.plan.datumDo}</Typography>
                <LinearProgress variant="determinate" value={pct} sx={{ mt: 1, height: 8, borderRadius: 4 }} />
                <Typography variant="caption">{p.dokoncenoPolozek}/{p.celkemPolozek} ({pct} %)</Typography>
              </CardContent>
            </Card>
          );
        })}
      </Stack>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Nový kontrolní plán</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <TextField label="Název" value={nazev} onChange={(e) => setNazev(e.target.value)} />
            <TextField label="Datum od" type="date" InputLabelProps={{ shrink: true }} value={datumOd} onChange={(e) => setDatumOd(e.target.value)} />
            <TextField label="Datum do" type="date" InputLabelProps={{ shrink: true }} value={datumDo} onChange={(e) => setDatumDo(e.target.value)} />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Zrušit</Button>
          <Button variant="contained" disabled={!nazev || !datumOd || !datumDo} onClick={ulozit}>Vytvořit</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default HydrantPlanyPage;
